import React from 'react';
import { FormularioPedido } from '../../../componentes/formulario-pedido/form-pedido';


const FormSalvarOS = (props) => {

    return <FormularioPedido tipo="ORDEM_SERVICO" titulo="Ordem de Serviço" { ...props } />
}

export {FormSalvarOS}; 

//module.exports = {FormSalvarPedido:FormSalvarPedido, Teste: Teste}; 